import React from 'react'
import PropTypes from 'prop-types'

export const Tag = ({ label, variant, className }) => (
  <span className={`wb-tag wb-tag--${variant} ${className}`}>{label}</span>
)

Tag.propTypes = {
  label: PropTypes.string,
  variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
  className: PropTypes.string,
}
